export default __webpack_public_path__ + "static/media/037-couch.e7647877.svg";